
import React from 'react';
import KLogo from '../../../../Assets/InforPage/K_Logo.png'
import InforAlliance from '../../../../Assets/InforPage/Infor allince.png'
import Kcs from "../../../../Assets/Navbar/ptkcs logo png total.png"
const PhotoCollab = () => {
  return (
    <div className="w-full min-h-screen p-8" style={{ backgroundColor: '#f8f9ff' }}>
      <div className="max-w-7xl mx-auto rounded-3xl overflow-hidden " style={{ backgroundColor: '#ffffff' }}>
        <div className="flex flex-col md:flex-row">
          {/* Left side - Photos */}
          <div className="md:w-3/5 p-12 relative">
            {/* Background decorative elements */}
            <div className="absolute top-1/2 left-1/2 w-96 h-96 -translate-x-1/2 -translate-y-1/2 rounded-full blur-3xl opacity-10"
              style={{ backgroundColor: '#7ed1ff' }}></div>
            
            <div className="relative h-[400px] flex items-center justify-between gap-6">
              {/* First image - Hexagon shape */}
              <div className="w-64 h-80  relative overflow-hidden transform hover:scale-105 transition-all duration-300 group"
                style={{
                  clipPath: 'polygon(10% 0, 90% 0, 100% 10%, 100% 90%, 90% 100%, 10% 100%, 0 90%, 0 10%)',
                  
                }}>
                <div className="absolute inset-0" style={{ backgroundColor: '#ffd7e5', opacity: 0 ,border:"red"}}></div>
                <img 
                  src="https://ik.imagekit.io/kqumni8l2/PhotoCollab/PhotoCollab_3.jfif?updatedAt=1737458457688"
                  alt="CEO pic 1"
                  className="w-full h-full object-cover"
                  
                />
              </div>
              
        {/* Second image - Circle shape */}
              <div className="w-64 h-64 relative overflow-hidden rounded-full transform hover:scale-105 transition-all duration-300 group">
                <div className="absolute inset-0" style={{ backgroundColor: '#d7f5ff', opacity: 0 }}></div>
                <img 
                  src="https://ik.imagekit.io/kqumni8l2/PhotoCollab/PhotoCollab_4.jfif?updatedAt=1737458782705"
                  alt="CEO pic 2"
                  className="w-full h-full object-cover"
                />
              </div>
              
       
            </div>
          </div>
          
          {/* Right side - Minimal Content */}
          <div className="md:w-2/5 p-12  ">
            <div className='flex'>
          <img src={Kcs} alt="KapilLogo" className='h-16 ' />    <h2
  className="text-5xl font-bold mb-8 flex items-center mt-2" // Use flex to align items
  style={{ 
    background: 'linear-gradient(135deg, #0012d8, #e60337, #FF0000)', // Gradient from blue to red to yellow
    WebkitBackgroundClip: 'text', 
    WebkitTextFillColor: 'transparent', 
    display: 'inline',
   
  }}
>
  
  {/* apilTech  */}
</h2>

         </div>



            
            <p className="text-md   leading-relaxed flex " style={{ color: '#64748b' }}>
           <span className='mt-3'> As an esteemed</span> <img src="https://ik.imagekit.io/kqumni8l2/inforAlliance%20PatnerLogo.png?updatedAt=1737438400542" alt="InforAlliance patner" className='h-10 ml-4 mt-2' />, 
            </p>
            <p className="text-md  leading-relaxed flex " style={{ color: '#64748b' }}>we provide trusted expertise and innovative solutions designed to elevate your business in a rapidly changing digital world</p>

            <div className="flex items-center gap-4">
              <div className="w-3 h-3 rounded-full" style={{ backgroundColor: '#FF0000' }}></div>
              <div className="w-3 h-3 rounded-full" style={{ backgroundColor: '#7F00FF' }}></div>
              <div className="w-3 h-3 rounded-full" style={{ backgroundColor: '#FFD93D' }}></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhotoCollab;